<template>
  <div class="mv-bg-main" style="overflow: scroll;">
    <el-card class="mr">
      <el-row>
        <el-col :span="6">
          <div class="task">
            <p class="center_task">今日交易总额</p>
            <p class="center_task" style="color: #7FFFAA;">{{totalAmount}}</p>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="task">
            <p class="center_task">支付成功率</p>
            <p class="center_task" style="color: #FFA500;">{{paySuccessRate}}</p>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="task">
            <p class="center_task">今日支付笔数</p>
            <p class="center_task" style="color: #FFD700;">{{payCount}}</p>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="task">
            <p class="center_task">未支付笔数</p>
            <p class="center_task" style="color: #F4606C;">{{cancelPayCount}}</p>
          </div>
        </el-col>
      </el-row>
      <el-row class="">
        <el-col :span="6">
          <div class="task">
            <p class="center_task">历史交易总额</p>
            <p class="center_task" style="color: #00BFFF;">{{hisTotalAmount}}</p>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="task">
            <p class="center_task">总支付成功率</p>
            <p class="center_task" style="color: #FF69B4;">{{hisPaySuccessRate}}</p>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="task">
            <p class="center_task">历史支付笔数</p>
            <p class="center_task" style="color: #0000CD;">{{hisPayCount}}</p>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="task">
            <p class="center_task">历史未支付笔数</p>
            <p class="center_task" style="color: #0060CD;">{{hisCancelPayCount}}</p>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="mr">
      <el-row >
        <el-col :span="12" style="padding: 5%;">
          <ve-line :data-empty="payMonthEmpty"   :xAxis="xAxis" :yAxis="yAxis" :legend="legend"  :data="payMonthData"></ve-line>
        </el-col>
        <el-col :span="12" style="padding: 5%;">
          <ve-line :data-empty="payMonthNumEmpty" :settings="chartSettings"  :xAxis="xAxis" :yAxis="yAxis" :legend="legend"  :data="payMonthNumData"></ve-line>
        </el-col>
      </el-row>
      <el-row >
        <el-col :span="12" >
          <ve-ring :data-empty="ringEmpty"  :data="ringData" :legend="legend"  :settings="chartVingSettings"></ve-ring>
        </el-col>
        <el-col :span="12" >
          <ve-funnel  :data-empty="funnelEmpty" :data="chartData" :legend="legend" :settings="chartfunnelSettings" ></ve-funnel>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.mr {
  margin: 10px;
}
.task {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  height: 80px;
}
.center_task {
  flex: 1;
  font-size: 16px;
  text-align: center;
}
.float {
  float: left;
}
</style>
<script>
import 'v-charts/lib/style.css'
export default {
  name: 'paymentAnalysis',
  data () {
    this.chartVingSettings = {
      radius: [50, 100],
      legendLimit: 0,
      label: {
        formatter: '{b} :{d}%'
      }
    }
    this.chartfunnelSettings = {
      label: {
        position: 'inside',
        formatter: '{b} :{d}%'
      }
    }
    this.chartSettings = {
      stack: { 'system': [] },
      area: true
    }
    this.extend = {
      grid: {
        right: '50%'
      }
    }
    this.ringSettings = {}
    return {
      payMonthData: {
        columns: ['日期', '取消', '失败', '成功'],
        rows: [
        ]
      },
      width: true,
      legend: {
        bottom: '0'
      },
      totalAmount: '',
      hisTotalAmount: '',
      paySuccessRate: '',
      hisPaySuccessRate: '',
      payCount: '',
      hisPayCount: '',
      cancelPayCount: '',
      hisCancelPayCount: '',
      payMonthEmpty: false,
      xAxis: {
        type: 'category',
        nameTextStyle: {
          fontStyle: 'bold',
          fontSize: '16'
        },
        axisLine: {
          onZero: false
        },
        nameGap: 25,
        nameLocation: 'center'
      },
      yAxis: {
        type: 'value',
        nameTextStyle: {
          fontStyle: 'bold',
          fontSize: '16'
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        nameGap: 15
      },
      payMonthNumEmpty: false,
      funnelEmpty: false,
      payMonthNumData: {
        columns: ['日期'],
        rows: [
        ]
      },
      ringEmpty: false,
      ringData: {
        columns: ['名称', '总数'],
        rows: [
        ]
      },
      chartData: {
        columns: ['订单名称', '总数'],
        rows: [
        ]
      }
    }
  },
  mounted () {
    this.query()
  },
  methods: {
    query () {
      let _this = this
      /* 查询笔数 */
      this.$axios({
        url: this.$API.analysis.queryPayCountStatistic,
        method: 'post',
        data: {sysIds: []}
      }).then((response) => {
        let data = response.data.resData
        this.hisCancelPayCount = data.hisCancelPayCount
        this.cancelPayCount = data.cancelPayCount
        this.hisPayCount = data.hisPayCount
        this.payCount = data.payCount
        this.hisPaySuccessRate = data.hisPaySuccessRate
        this.paySuccessRate = data.paySuccessRate
        this.hisTotalAmount = data.hisTotalAmount
        this.totalAmount = data.totalAmount
      }).catch((err) => {
        console.log(err)
      })
      /* 饼图 */
      this.$axios({
        url: this.$API.analysis.queryPayAmountByVirtualSeller,
        method: 'post',
        data: {sysIds: []}
      }).then((response) => {
        let data = response.data.resData.resultList
        if (data.length) {
          _this.ringEmpty = false
        } else {
          _this.ringEmpty = true
        }
        for (let v of data) {
          let op = {}
          op['名称'] = v.virtualSellerName
          op['总数'] = v.totalAmount
          _this.ringData.rows.push(op)
        }
      }).catch((err) => {
        console.log(err)
      })
      /* 漏斗图 */
      this.$axios({
        url: this.$API.analysis.queryPayConversionRate,
        method: 'post',
        data: {sysIds: []}
      }).then((response) => {
        let data = response.data.resData
        if (data.payCount === 0) {
          _this.funnelEmpty = true
        } else {
          _this.funnelEmpty = false
        }
        if (data.payCount) {
          let op = {}
          op['订单名称'] = '支付订单'
          op['总数'] = data.payCount
          this.chartData.rows.push(op)
        }
        if (data.paySuccCount) {
          let o = {}
          o['订单名称'] = '支付成功订单'
          o['总数'] = data.paySuccCount
          this.chartData.rows.push(o)
        }
      }).catch((err) => {
        console.log(err)
      })
      /* 折线图 */
      this.$axios({
        url: this.$API.analysis.queryPayCountByDateType,
        method: 'post',
        data: {dateType: 2}
      }).then((response) => {
        let data = response.data.resData.resultList
        if (data.length) {
          _this.payMonthEmpty = false
        } else {
          _this.payMonthEmpty = true
        }
        for (let v of data) {
          let op = {}
          op['日期'] = v.payDate
          for (let o of v.payDetail) {
            op['取消'] = o.payCancelCount
            op['失败'] = o.payFailedCount
            op['成功'] = o.paySuccessCount
          }
          this.payMonthData.rows.push(op)
        }
      }).catch((err) => {
        console.log(err)
      })
      /* 面积图 */
      this.$axios({
        url: this.$API.analysis.queryPayCountByVirtualSeller,
        method: 'post',
        data: {dateType: 2}
      }).then((response) => {
        let data = response.data.resData.resultList
        if (data.length) {
          _this.payMonthNumEmpty = false
        } else {
          _this.payMonthNumEmpty = true
        }
        console.log(data)
        let arr = []
        for (let v of data) {
          let op = {}
          op['日期'] = v.payDate
          for (let k of v.payDetail) {
            arr.push(k.virtualSellerName)
            op[k.virtualSellerName] = k.paySuccessCount
          }
          this.payMonthNumData.rows.push(op)
        }
        arr = Array.from(new Set(arr))
        for (let v of arr) {
          this.payMonthNumData.columns.push(v)
        }
        this.chartSettings.stack.system = arr
        console.log(this.chartSettings.stack.system)
        console.log(this.payMonthNumData)
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/home/paymentAnalysis.vue